import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomReuseStrategy implements RouteReuseStrategy {
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false; // Never detach any route
  }

  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {
    // Empty, since we don't store routes
  }

  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false; // Never reuse stored routes
  }

  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null; // Nothing to retrieve
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig ? false : true;
  }
}
